export const appConfig = {
  ENVIRONMENT: process.env.REACT_APP_CUSTOM_ENV,
};
